module.exports = __webpack_public_path__ + "static/media/kylee.0d6496f0.jpg";